export const EliteLandingPageRemark = ({ isElite, children }: { isElite?: boolean; children: any }) => {
  return (
    <div className={`flex gap-[11px] w-full ${isElite ? 'text-[#CC5C2D]' : 'text-[#095EB2]'} text-[13px]`}>
      <div className={`${isElite ? 'bg-[#CC5C2D] w-[2px]' : 'bg-[#095EB2] w-[4px]'} rounded-[10px] `}></div>
      <div className='flex flex-1'>{children}</div>
    </div>
  )
}
